import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';

import type { Scope3WasteCodeResolutionResponse } from '../types/scope3-waste-code';

import { useGHGOrganizationId } from './use-ghg-organization-id';

import { createApiClient } from '@/lib/api-client';

export const scope3WasteCodeKeys = {
  all: ['scope3-waste-codes'] as const,
  resolve: (orgId: string, code: string) =>
    [...scope3WasteCodeKeys.all, 'resolve', orgId, code] as const,
};

export function useResolveScope3WasteCode(
  code: string,
  options?: { enabled?: boolean }
) {
  const { getToken } = useAuth();
  const orgId = useGHGOrganizationId() ?? '';

  return useQuery({
    queryKey: scope3WasteCodeKeys.resolve(orgId, code),
    queryFn: async () => {
      const apiClient = createApiClient({
        getAuthToken: getToken,
      });
      const searchParams = new URLSearchParams({ code });
      return apiClient.get<Scope3WasteCodeResolutionResponse>(
        `/organizations/${orgId}/ghg/scope3-waste-codes/resolve?${searchParams.toString()}`
      );
    },
    enabled: Boolean(orgId) && Boolean(code.trim()) && (options?.enabled ?? true),
  });
}
